import { Injectable } from "@angular/core";
import { EnvironmentService } from "./environment.service";

@Injectable({providedIn: 'root'})
export class AdminAuthService {
    public haveAdminAccess: boolean = false;

    constructor(environmentService: EnvironmentService) {
        if (!environmentService.isProduction())
            this.haveAdminAccess = true;
    }
}